/**
 * SniperGate — password gate for the StreamRift Sniper execution submenu.
 *
 * Hash-BOUND (unlike StreamRift's unbound research gate): rotating the password
 * invalidates already-unlocked tabs. This is the second, independent layer on
 * top of the relay's admin-only role check — a fat-finger deterrent, never the
 * auth boundary.
 *
 * The shipped hash below is an UNUSABLE placeholder (SHA-256 of a random
 * string), so the gate is locked for everyone until the operator replaces
 * SNIPER_HASH with the SHA-256 hex of their chosen password. Keep it out of
 * the trader-reachable world: the /sniper route only renders for role==='admin'.
 */

import { type GateNamespace } from '@/lib/infra/gateStorage';
import { PasswordGate } from '@/components/organisms/PasswordGate';

// SHA-256 of the operator password. Rotate with `echo -n '<password>' |
// shasum -a 256`; rotating logs every open Sniper tab out (hash-bound namespace).
const SNIPER_HASH = '4a07a4310034102668a862f2ec7d3ba7416937b2f85c90b38257cf5b13093b0c';

/** Session-scoped and hash-bound. */
export const SNIPER_GATE: GateNamespace = { sessionKey: 'sniper_unlocked', hashKey: 'sniper_hash' };

export { SNIPER_HASH };

export function SniperGate({ onUnlock }: { onUnlock: () => void }) {
  return (
    <PasswordGate
      title="StreamRift Sniper"
      subtitle="Execution layer — operator password"
      namespace={SNIPER_GATE}
      expectedHash={SNIPER_HASH}
      onUnlock={onUnlock}
    />
  );
}
